import controller from './authentication.controller';
import template from './authentication.html';

let authenticationComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default authenticationComponent;



// WEBPACK FOOTER //
// ./client/app/features/authentication/authentication.component.js